'use client'

import GlobalError from '@/components/composites/errors/error'

interface ErrorPageProps {
  error: Error & { digest?: string }
  reset: () => void
}

const ErrorPage = ({ error, reset }: ErrorPageProps) => {
  return <GlobalError />
}
export default ErrorPage
